/**
 * Local environment detection.
 *
 * Used by features that should only activate in local/dev contexts —
 * e.g. local-multisite-auto-swap, where deploying to a new site must
 * first stop the previously running site to free shared docker
 * container names and ports. In production each site has its own
 * server, so the swap must never run there.
 *
 * Resolution order (fail-safe — defaults to false on uncertainty):
 *   1. window.ENV.IS_LOCAL  — runtime-injected boolean string
 *   2. hostname pattern     — localhost / 127.* / *.local / 10.* / 192.168.*
 *   3. fallback             — false (treat as production)
 */
export function isLocalEnvironment(): boolean {
  if (typeof window === 'undefined') return false

  const runtimeFlag = (window as unknown as { ENV?: { IS_LOCAL?: unknown } }).ENV?.IS_LOCAL
  if (runtimeFlag === 'true' || runtimeFlag === true) return true
  if (runtimeFlag === 'false' || runtimeFlag === false) return false

  const host = window.location?.hostname ?? ''
  if (host === 'localhost' || host === '127.0.0.1') return true
  if (host.endsWith('.local')) return true
  if (/^192\.168\./.test(host)) return true
  if (/^10\./.test(host)) return true

  return false
}
